import React, { useState } from 'react';
import { GlobeIcon } from 'lucide-react';
import { cn } from '@cotera/client/v0/lib/utils';
import { faviconUrl } from './web-tool-renderer-utils';

type FaviconProps = {
  /** Page URL or hostname; the favicon is derived from its host. */
  url: string | null | undefined;
  /** Requested icon resolution in px. Display size is controlled by className. */
  resolution?: number;
  /** Applied to both the <img> and the fallback icon for consistent sizing. */
  className?: string;
};

/**
 * Renders a site favicon, falling back to a neutral globe icon when the URL
 * has no derivable host or the image fails to load.
 */
export const Favicon: React.FC<FaviconProps> = ({
  url,
  resolution = 64,
  className,
}) => {
  const src = faviconUrl(url, resolution);
  const [failed, setFailed] = useState(false);

  if (src === undefined || failed) {
    return (
      <GlobeIcon
        className={cn('text-muted-foreground', className)}
        aria-hidden
      />
    );
  }

  return (
    <img
      src={src}
      alt=""
      aria-hidden
      loading="lazy"
      className={cn('object-contain', className)}
      onError={() => setFailed(true)}
    />
  );
};
